export default {
      id: "user-64-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "sprite.svg#user-64",
      toString: function () {
        return this.url;
      }
    }